import { FC } from "react"
import { BlankStateSection } from "src/components/shared/BlankStateSection"
import { CenteredSpinner } from "src/components/shared/CenteredSpinner"
import { IHallBookingReceipt } from "src/domain/entities"
import { HallReceiptListView } from "."

interface Props {
	list: IHallBookingReceipt[]
	isLoading: boolean
	onUpdate: (income: IHallBookingReceipt) => void
	onDelete: (income: IHallBookingReceipt) => void
	onAddClick: () => void
}

export const HallBookingReceiptListController: FC<Props> = ({
	isLoading,
	list,
	onDelete,
	onUpdate,
	onAddClick,
}) => {
	if (isLoading) return <CenteredSpinner />

	if (list.length === 0) {
		return <BlankStateSection message="No Receipts found." onAddClick={onAddClick} />
	}

	return <HallReceiptListView list={list} onUpdate={onUpdate} onDelete={onDelete} />
}
